<template>
  <div>
    <div slot="header" class="box-card-header">
      <div style="text-align: center">{{news.title}}</div>
    </div>
    <div class="news-content-container">
      <div class="sub">{{news.publishOrigin}}<span class="date">{{news.publishDate}}</span></div>
      <div class="main">
        <div v-html="content"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {newsDetail} from 'src/api/stadiumApi'
  import {isNotEmpty, escape2Html} from 'src/utils/myUtils'
  import {IMAGE_BASE_URL} from 'src/config/pathConfig'

  export default {
    data () {
      return {
        news: {},
        id: '',
        content: ''
      }
    },
    components: {},
    mounted () {
      this.$nextTick(function () {
        this.id = this.$route.query.id
        this.onLoadNewsDetail()
      })
    },
    watch: {},
    methods: {
      onLoadNewsDetail () {
        if (isNotEmpty(this.id)) {
          newsDetail(this.id).then((resp) => {
            if (resp !== null) this.news = resp
            let content = escape2Html(resp.content)
            content = content.replace(/src="\/hgnc\/upload\//g, 'src="' + IMAGE_BASE_URL + '/upload/')
            this.content = content
            this.$store.dispatch('updateCurrentNewsSortId', resp.sortModel.id)
          })
        }
      }
    }
  }
</script>
<style>
</style>




// WEBPACK FOOTER //
// src/pages/news/Detail.vue